<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>服务人员</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="姓名"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="sex"
            label="性别"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.sex==1?'男':'女'}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="tel"
            label="电话"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="nodeName"
            label="所属网点"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="80"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-edit-outline" style="fontSize:19px;color:#000"></i>
                        </el-button>
                        <el-popconfirm
                            title="确定删除吗？"
                            @confirm="dele(scope.row)"
                        >
                            <el-button type="text" slot="reference" size="mini" class="btn" >
                                <i class="el-icon-delete" style="color:red;fontSize:19px"></i>
                            </el-button>
                        </el-popconfirm>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'"  :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:50%;margin:0 auto;marginTop:-50px">
            <div class="dialogline"></div>
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules">
                    <el-form-item label="人员姓名" label-width="80px" prop="name" >
                        <el-input v-model="dialogForm.name" autocomplete="off" placeholder="请输入姓名" ></el-input>
                    </el-form-item>
                    <el-form-item label="人员性别" label-width="80px" prop="sex">
                        <el-select  v-model="dialogForm.sex" style="width:100%">
                            <el-option label="男" value='1'></el-option>
                            <el-option label="女" value='2'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="80px" prop="tel" >
                        <el-input v-model="dialogForm.tel" autocomplete="off" placeholder="请输入电话" ></el-input>
                    </el-form-item>
                    <el-form-item label="人员类别" label-width="80px" prop="type">
                        <el-select  v-model="dialogForm.type" >
                            <el-option label="特种人员" value='1'></el-option>
                            <el-option label="普通人员" value='2'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属网点" label-width="80px" prop="nodeId">
                        <el-select  v-model="dialogForm.nodeId" >
                            <el-option v-for="(item,i) in nodeList" :key="i" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注信息" label-width="80px" prop="remark" >
                        <el-input type="textarea" :rows="3" v-model="dialogForm.remark" autocomplete="off" placeholder="添加备注信息" ></el-input>
                    </el-form-item>
                </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            nodeOption:{
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                name: '',
                sex: '1',
                type: '1',
                tel: '',
                nodeId: '1',
                remark: ''
            },
            formRules:{
                name:[{
                    required: true,
                    message: "请输入姓名",
                    trigger: "blur"
                }],
                type:[{
                    required: true,
                    message: "请选择人员类别",
                    trigger: "blur"
                }],
                nodeId:[{
                    required: true,
                    message: "请选择网点",
                    trigger: "blur"
                }],
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            list: [],
            inputValue: '',
            nodeList: [],
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.ServeCustomerList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //获取网点列表
        getPersonNodeList(option){
            this.$api.PersonNodeList(option).then(res=>{
                this.nodeList = res.data.data.data;
            })
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                name: '',
                sex: '1',
                type: '1',
                tel: '',
                nodeId: '',
                remark: ''
            };
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: row.id,
                name: row.name,
                sex: String(row.sex),
                type: String(row.type),
                tel: row.tel,
                nodeId: String(row.nodeId),
                remark: row.remark
            };
        },
        //删除按钮
        dele(row){
            this.$api.DelCustomer({id:row.id}).then(res=>{
                if(res.data.code == 200){
                    this.$notify({
                        message: res.data.msg,
                        type: 'success'
                    })
                    this.getList(this.option);
                }else{
                    this.$notify({
                        message: res.data.msg,
                        type: 'error'
                    })
                }
            })
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    this.dialogForm.type = Number(this.dialogForm.type);
                    this.dialogForm.sex = Number(this.dialogForm.sex);
                    this.dialogForm.nodeId = Number(this.dialogForm.nodeId);
                    if(this.isEdit){
                        this.$api.ServeUpdateCustomer(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }else{
                        this.$api.ServeAddCustomer(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }
                    this.dialogFormVisible = false;
                }else{
                    return false
                }
            })
        }
    },
    mounted(){
        this.getList(this.option);
        this.getPersonNodeList(this.nodeOption);
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
.el-select{
    width:100%
}
</style>